import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ExamMenu() {

  const navigate = useNavigate();
  return (
    <div className="list-group">
      <a href="#" className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
        By system sugesstion
        <span className="badge bg-danger ms-1">99+</span>
      </a>

      <a href="#" onClick={()=> navigate("./category")} className="list-group-item list-group-item-action">
        By Category manual
      </a>
      <a href="#" onClick={()=> navigate("./category")} className="list-group-item list-group-item-action">
        Random test
      </a>
    </div>

  );
}
